import { render, staticRenderFns } from "./painel-flutuante.vue?vue&type=template&id=1fa86e70&scoped=true&"
import script from "./painel-flutuante.vue?vue&type=script&lang=js&"
export * from "./painel-flutuante.vue?vue&type=script&lang=js&"
import style0 from "./painel-flutuante.vue?vue&type=style&index=0&id=1fa86e70&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa86e70",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VExpandTransition,VProgressCircular})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fa86e70')) {
      api.createRecord('1fa86e70', component.options)
    } else {
      api.reload('1fa86e70', component.options)
    }
    module.hot.accept("./painel-flutuante.vue?vue&type=template&id=1fa86e70&scoped=true&", function () {
      api.rerender('1fa86e70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/painel-do-chat/painel-flutuante.vue"
export default component.exports